declare global {
	interface Navigator {
		userLanguage?: string
	}
}

export function getUserLanguage() {
	return (navigator.languages && navigator.languages[0]) || navigator.userLanguage || navigator.language || 'en'
}
